import { AccueilDto } from '../../data-access/http/dto/accueil.dto'
import { Accueil, AccueilDetail } from '../../../shared/models/accueil'

export class AccueilMapper {
  static dtoToModel(dto: AccueilDto): Accueil {
    return {
      id: dto.id,
      nom: dto.salarie_nom || dto.interimaire_nom || dto.nom || '',
      prenom: dto.salarie_prenom || dto.interimaire_prenom || dto.prenom || '',
      codeGender: dto.codeGender,
      codeNationalite: dto.codeNationalite,
      nomNationalite: dto.nomNationalite,
      nomTypeContrat: dto.nomTypeContrat,
      emploi: dto.emploi,
      dateEntree: AccueilMapper.parseBackDate(dto.dateEntree) ?? '',
      dateSortie: AccueilMapper.parseBackDate(dto.dateSortie),
      pchAccueilSecuritePieceJointeId: dto.pchAccueilSecuritePieceJointeId ?? null,
    }
  }

  static dtosToModel(dtos: AccueilDto[]): Accueil[] {
    if (!dtos) return []
    return dtos.map(AccueilMapper.dtoToModel)
  }

  static dtoToDetailModel(dto: AccueilDto): AccueilDetail {
    return {
      ...AccueilMapper.dtoToModel(dto),
      dateDeNaissance: AccueilMapper.parseBackDate(dto.dateDeNaissance),
      nomGender: dto.nomGender,
      qualification: dto.qualification,
      dateDebutContrat: AccueilMapper.parseBackDate(dto.dateDebutContrat),
      dateFinContrat: AccueilMapper.parseBackDate(dto.dateFinContrat),
      codeAgence: dto.codeAgence,
      nomAgence: dto.nomAgence,
      commentaire: dto.commentaire ?? null,
      lienDriveTitreSejour: dto.lienDriveTitreSejour ?? null,
      schengenNationalite: dto.schengenNationalite,
    }
  }

  private static parseBackDate(value: string | null | undefined): string | null {
    if (!value || value.length < 8) return null
    const year = value.substring(0, 4)
    const month = value.substring(4, 6)
    const day = value.substring(6, 8)
    return `${year}-${month}-${day}`
  }
}
